export { StickyBar } from './sticky-bar';
export type { StickyBarProps } from './sticky-bar';
